import React from "react"
import { Link } from "react-router-dom";
import { useLanguageContext } from "../context/languageContext";
import businessConfig from "../config/business";

export const Footer = () => {
    const { t } = useLanguageContext();
    return (
        <footer className="bg-transparent pt-2 pb-2 px-6 text-center">
            <div className="max-w-7xl mx-auto space-y-2">
                {/* Visual Separator */}
                <div className="flex justify-center mb-6">
                    <div className="h-px w-8 bg-slate-200"></div>
                </div>

                {/* Dot-separated minimalist links */}
                <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs font-bold uppercase tracking-[0.1em] text-slate-500">
                    <Link to="/terms" className="hover:text-slate-900 transition-colors">{t("Terms")}</Link>
                    <span className="w-1 h-1 rounded-full bg-slate-200"></span>
                    <Link to="/privacy" className="hover:text-slate-900 transition-colors">{t("Privacy")}</Link>
                    <span className="w-1 h-1 rounded-full bg-slate-200"></span>
                    <a href={businessConfig.website} target="_blank" rel="noreferrer" className="hover:text-slate-900 transition-colors">
                        {t("Website", "Website")}
                    </a>
                </div>

                {/* Compressed Copyright - Ghost Style */}
                <div className="pt-2">
                    <p className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 select-none">
                        {businessConfig.legalName} © {new Date().getFullYear()}
                    </p>
                </div>
            </div>
        </footer>
    );
};
